var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "6",
      "height": "22"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#fff",
      "fill-rule": "evenodd",
      "d": "M5.083 4.848H.917V.68h4.166v4.167Zm0 16.666H.917v-12.5h4.166z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }